import { useAnalytics } from "../lib/analytics";

/** Componente "invisibile" che attiva il tracking GA4 (condizionato al consenso). */
export default function AnalyticsTracker() {
    useAnalytics();
    return null;
}
